export const translations = {
  tr: {
    // Navbar
    products: 'Ürünler',
    operationalRental: 'Operasyonel Kiralama',
    professional: 'Endüstriyel Temizlik Makineleri',
    solutions: 'Çözümler',
    service: 'Servis',
    about: 'Hakkımızda',
    company: 'Şirket',
    sustainability: 'Sürdürülebilirlik',
    career: 'Kariyer',
    contact: 'İletişim',
    
    // Home
    homeRentalTitle: 'Operasyonel Kiralama',
    homeRentalDesc: 'Esnek kiralama çözümlerimizi keşfedin',
    homeProfessionalTitle: 'Profesyonel temizlik',
    homeProfessionalDesc: 'Tüm ürün yelpazemizi keşfedin',
    learnMore: 'Daha fazlasını göster',
    
    // Featured Sections
    featuredSustainabilityTitle: 'Sorumlulukla değer yaratmak',
    featuredSustainabilityDesc: 'Ürün ve hizmetlerin ötesinde sürdürülebilirliği keşfedin',
    featuredTechnologyTitle: 'Elerein Teknolojisi',
    featuredTechnologyDesc: 'Yenilikçi temizlik çözümleri ile tanışın',
    featuredNewMachineTitle: 'Elerein Tasarım Gücü',
    featuredNewMachineDesc: 'E130. Başarıya giden yol, sadelik',
    featuredCareerTitle: 'Gelecek vaat eden bir kariyer yolu',
    featuredCareerDesc: 'Bize katılın ve ilham verici fikirlerinizi hayata geçirin',
    featuredContactTitle: 'Taleplerinizi memnuniyetle karşılamak için buradayız',
    featuredContactDesc: 'Bizimle iletişime geçin ve temizlikte karşılaştığınız her türlü zorluk için aradığınız çözümü bulun',
    readMore: 'Devamını oku',
    
    // Footer
    allRightsReserved: 'Tüm hakları saklıdır.',
    turkeyDistributor: 'Türkiye distribütörü Service Macro',
    footerProducts: 'Ürünler',
    footerServices: 'Hizmetler',
    footerCompany: 'Şirket',
    footerSupport: 'Destek',
    
    // Contact
    contactTitle: 'İletişim',
    contactSubtitle: 'Size yardımcı olmak için buradayız',
    getInTouch: 'Bizimle İletişime Geçin',
    contactDesc: 'Sorularınız ve talepleriniz için bize ulaşabilirsiniz. Uzman ekibimiz size en kısa sürede yardımcı olacaktır.',
    address: 'Adres',
    phone: 'Telefon',
    email: 'E-posta',
    workingHours: 'Çalışma Saatleri',
    workingHoursDesc: 'Pazartesi - Cuma: 09:00 - 18:00\nCumartesi: 09:00 - 14:00\nPazar: Kapalı',
    sendMessage: 'Mesaj Gönder',
    fullName: 'Ad Soyad',
    subject: 'Konu',
    message: 'Mesaj',
    send: 'Gönder',
    
    // Products
    ourProducts: 'Ürünlerimiz',
    view: 'İncele',
    catalog: 'Katalog',
    
    // PDF Brochure
    brochureTitle: 'Endüstriyel Temizlik Makineleri Kataloğu',
    downloadBrochure: 'PDF Broşür İndir',
    technicalSpecs: 'Teknik Özellikler',
    specification: 'Özellik',
    unit: 'Birim',
    value: 'Değer',
    previewOrDownload: 'PDF\'i yeni sekmede önizlemek ister misiniz? (İptal = İndir)',
    
    // Catalog
    catalogTitle: 'Elerein Ürün Kataloğu 2025',
    backButton: 'Geri Dön',
    downloadPDF: 'PDF İndir',
    viewCatalog: 'Kataloğu Görüntüle',
    
    // About
    aboutTitle: 'Hakkımızda',
    aboutSubtitle: 'ServiceMacro - Endüstriyel Temizlik Çözümleri',
    ourValues: 'Değerlerimiz',
    quality: 'Kalite',
    efficiency: 'Verimlilik',
    customerFocus: 'Müşteri Odaklılık',
    partnershipTitle: 'ELEREIN Partnerliği',
    
    // Professional
    professionalTitle: 'Profesyonel Temizlik',
    professionalSubtitle: 'Endüstriyel tesisler ve ticari alanlar için güçlü çözümler',
    warranty24: '24 Ay Garanti',
    highInspection: 'Yüksek Denetim',
    spareParts: 'Yedek Parça',
    technicalSupport: 'Teknik Destek',
    whyElerein: 'Neden Elerein\'i Tercih Etmelisiniz?',
    productCatalogs: 'Ürün Katalogları',
    downloadAllCatalogs: 'Tüm Katalogları İndirin',
    
    // Rental
    rentalTitle: 'Operasyonel Kiralama',
    rentalSubtitle: 'Esnek ve ekonomik temizlik ekipmanı kiralama çözümleri',
    aiAssisted: 'AI Destekli',
    rentalQuote: 'Makine değil, sorunsuz, sürdürülebilir ve kontrol altında bir temizlik sistemi kiralayın',
    operationBenefits: 'Operasyon Yönetiminde Net Veri Akışı',
    operationBenefitsDesc: 'AI destekli akıllı kiralama modeli ile tüm süreçlerinizi kontrol altında tutun',
    
    financeTitle: 'Finans',
    financeFixed: 'Sabit Aylık Maliyet',
    financeFixedDesc: 'Öngörülebilir bütçe planlaması',
    financeNoCap: 'Sıfır CAPEX',
    financeNoCapDesc: 'Başlangıç yatırımı yok',
    financePredictable: 'Öngörülebilir',
    financePredictableDesc: 'Gizli maliyet yok',
    
    operationTitle: 'Operasyon',
    operationContinuity: 'Kesintisiz Hizmet',
    operationContinuityDesc: 'Proaktif bakım ve destek',
    operationAI: 'AI İzleme',
    operationAIDesc: 'Gerçek zamanlı performans takibi',
    operationMaintenance: 'Periyodik Bakım',
    operationMaintenanceDesc: 'Tüm bakım dahil',
    
    procurementTitle: 'Satınalma',
    procurementSingle: 'Tek Tedarikçi',
    procurementSingleDesc: 'Basitleştirilmiş tedarik süreci',
    procurementSimple: 'Tek Sözleşme',
    procurementSimpleDesc: 'Kolay yönetim',
    
    managementTitle: 'Yönetim',
    managementPerformance: 'Performans İzleme',
    managementPerformanceDesc: 'Detaylı raporlama ve analiz',
    managementRisk: 'Risk Yönetimi',
    managementRiskDesc: 'Azaltılmış operasyonel risk',
    
    comparisonTitle: 'Operasyonel, Yönetim ve Finansal Değerlendirme',
    comparisonDesc: 'Klasik satın alma ile AI destekli kiralama modelini karşılaştırın',
    comparisonCriteria: 'Değerlendirme Kriteri',
    comparisonClassic: 'Klasik Satın Alma',
    comparisonAI: 'AI Destekli Akıllı Kiralama',
    comparisonInvestment: 'Başlangıç Yatırımı',
    comparisonClassicInv: 'Yüksek CAPEX gerekli',
    comparisonAIInv: 'Sıfır CAPEX',
    comparisonCashFlow: 'Nakit Akışı',
    comparisonClassicCash: 'Büyük başlangıç ödemesi',
    comparisonAICash: 'Öngörülebilir aylık ödeme',
    comparisonCost: 'Toplam Sahip Olma Maliyeti',
    comparisonClassicCost: 'Yüksek ve değişken',
    comparisonAICost: 'Sabit ve öngörülebilir',
    comparisonMaintenance: 'Bakım & Onarım',
    comparisonClassicMain: 'Ek maliyet ve zaman',
    comparisonAIMain: 'Dahil ve planlanmış',
    comparisonControl: 'Operasyon Kontrolü',
    comparisonClassicControl: 'Manuel takip',
    comparisonAIControl: 'AI destekli otomatik izleme',
    
    rentalProductsDesc: 'Tüm ELEREIN temizlik makineleri kiralama modelinde mevcuttur',
    rentalCTA: 'AI Destekli Kiralama Modeliyle Tanışın',
    rentalCTADesc: 'Size özel çözüm için hemen iletişime geçin',
    economicSolution: 'Ekonomik Çözüm',
    flexibleTerms: 'Esnek Süreler',
    maintenanceIncluded: 'Bakım Dahil',
    renewalGuarantee: 'Yenileme Garantisi',
    rentalAdvantages: 'Operasyonel Kiralama Avantajları',
    availableProducts: 'Kiraya Verilebilir Ürünler',
    requestQuote: 'Teklif İste',
    
    // Product Descriptions
    e1Desc: 'Kompakt ve güçlü zemin temizleme makinesi. Dar alanlar için ideal çözüm.',
    e30Desc: '30 litre tank kapasiteli kompakt temizlik makinesi. Orta ölçekli alanlar için mükemmel performans.',
    e60Desc: '55 litre itmeli temizlik makinesi. Bataryalı ve geniş alanları kolayca temizleyebileceğiniz bir model.',
    e100Desc: '110 litre tank ve 4.200 m2/saat çalışma kapasiteli temizlik makinesi.',
    e130Desc: '130 litre tank ve 5.300 m2/saat çalışma kapasiteli temizlik makinesi.',
    e250Desc: '250 litre tank kapasiteli endüstriyel binicili temizlik makinesi. Büyük tesisler için ideal.',
    
    // Product Names
    e1Name: 'E1 Zemin Temizleme Makinesi',
    e30Name: 'E30 Zemin Temizleme Makinesi',
    e60Name: 'E60 Zemin Temizleme Makinesi',
    e100Name: 'E100 endüstriyel sürücülü tip zemin temizleme makinesi',
    e130Name: 'E130 endüstriyel sürücülü tip zemin temizleme makinesi',
    e250Name: 'E250 Endüstriyel Temizlik Makinesi',
    compactName: 'Kompakt Zemin Temizleyici',
    
    // About Page
    aboutContent1: 'ServiceMacro, endüstriyel temizlik makineleri satış, kiralama ve satış sonrası hizmetleri alanlarında faaliyet gösteren, Türkiye merkezli bir teknoloji ve hizmet şirketidir.',
    aboutContent2: 'Sektörde 20 yılı aşkın deneyimin getirdiği birikimle kurulan şirketimiz, temizlik ekipmanları pazarında satış sonrası hizmet kalitesini yükseltmeyi, operasyonel verimliliği artırmayı ve sürdürülebilir çözümler sunmayı hedeflemektedir.',
    aboutContent3: 'ServiceMacro, satış ve kiralama süreçlerinden teknik servise, yedek parça temininden ikinci el operasyonlarına kadar tüm hizmetlerini marka bağımsız total tedarikçi anlayışıyla sunmaktadır.',
    aboutContent4: 'Müşteri memnuniyetini merkeze alan yapısı, güçlü teknik altyapısı ve deneyimli ekibiyle, iş ortaklarının ihtiyaçlarına en uygun çözümü hızlı ve etkin şekilde sağlamaktadır.',
    aboutContent5: 'Şirketimiz, ekipmanların optimum süreyle kullanılmasını, çevreye duyarlı geri dönüşüm süreçleriyle sürdürülebilir bir döngü içinde yönetilmesini esas alır.',
    aboutContent6: 'Bu yaklaşım, ServiceMacro\'nun yalnızca ürün sağlayan bir firma olmanın ötesine geçerek, endüstriyel temizlik sektöründe katma değer yaratan bir çözüm ortağı konumuna ulaşmasını sağlamıştır.',
    aboutContent7: 'ELEREIN Avrupa Partnerliği ile güçlenen ServiceMacro, temizlik makineleri alanında geniş ürün portföyü ve teknik kabiliyetiyle Avrupa genelinde hizmet sağlayan saygın bir marka haline gelmiştir.',
    aboutContent8: 'Gelişen teknolojiye uyumlu, çevreci ve yenilikçi hizmet anlayışıyla ServiceMacro, sektörde kalite standartlarını her geçen gün daha da ileriye taşımaktadır.',
    partnershipContent1: 'ELEREIN Avrupa Partnerliği ile güçlenen ServiceMacro, temizlik makineleri alanında geniş ürün portföyü ve teknik kabiliyetiyle Avrupa genelinde hizmet sağlayan saygın bir marka haline gelmiştir.',
    partnershipContent2: '20 yılı aşkın sektör deneyimimiz ve ELEREIN\'in yenilikçi teknolojileriyle birleşerek, müşterilerimize en iyi hizmeti sunuyoruz.'
  },
  
  en: {
    // Navbar
    products: 'Products',
    operationalRental: 'Operational Rental',
    professional: 'Industrial Cleaning Machines',
    solutions: 'Solutions',
    service: 'Service',
    about: 'About',
    company: 'Company',
    sustainability: 'Sustainability',
    career: 'Career',
    contact: 'Contact',
    
    // Home
    homeRentalTitle: 'Operational Rental',
    homeRentalDesc: 'Discover our flexible rental solutions',
    homeProfessionalTitle: 'Professional cleaning',
    homeProfessionalDesc: 'Discover our full product range',
    learnMore: 'Learn more',
    
    // Featured Sections
    featuredSustainabilityTitle: 'Creating value with responsibility',
    featuredSustainabilityDesc: 'Discover sustainability beyond products and services',
    featuredTechnologyTitle: 'Elerein Technology',
    featuredTechnologyDesc: 'Discover innovative cleaning solutions',
    featuredNewMachineTitle: 'Elerein Design Power',
    featuredNewMachineDesc: 'E130. Simplicity is the path to success',
    featuredCareerTitle: 'A promising career path',
    featuredCareerDesc: 'Join us and bring your inspiring ideas to life',
    featuredContactTitle: 'We are here to meet your demands with pleasure',
    featuredContactDesc: 'Contact us and find the solution you are looking for every challenge you face in cleaning',
    readMore: 'Read more',
    
    // Footer
    allRightsReserved: 'All rights reserved.',
    turkeyDistributor: 'Turkey distributor Service Macro',
    footerProducts: 'Products',
    footerServices: 'Services',
    footerCompany: 'Company',
    footerSupport: 'Support',
    
    // Contact
    contactTitle: 'Contact',
    contactSubtitle: 'We are here to help you',
    getInTouch: 'Get In Touch',
    contactDesc: 'You can reach us for your questions and requests. Our expert team will assist you as soon as possible.',
    address: 'Address',
    phone: 'Phone',
    email: 'E-mail',
    workingHours: 'Working Hours',
    workingHoursDesc: 'Monday - Friday: 09:00 - 18:00\nSaturday: 09:00 - 14:00\nSunday: Closed',
    sendMessage: 'Send Message',
    fullName: 'Full Name',
    subject: 'Subject',
    message: 'Message',
    send: 'Send',
    
    // Products
    ourProducts: 'Our Products',
    view: 'View',
    catalog: 'Catalog',
    
    // PDF Brochure
    brochureTitle: 'Industrial Cleaning Machines Catalog',
    downloadBrochure: 'Download PDF Brochure',
    technicalSpecs: 'Technical Specifications',
    specification: 'Specification',
    unit: 'Unit',
    value: 'Value',
    
    // Catalog
    catalogTitle: 'Elerein Product Catalog 2025',
    backButton: 'Back',
    downloadPDF: 'Download PDF',
    viewCatalog: 'View Catalog',
    
    // About
    aboutTitle: 'About Us',
    aboutSubtitle: 'ServiceMacro - Industrial Cleaning Solutions',
    ourValues: 'Our Values',
    quality: 'Quality',
    efficiency: 'Efficiency',
    customerFocus: 'Customer Focus',
    partnershipTitle: 'ELEREIN Partnership',
    
    // Professional
    professionalTitle: 'Professional Cleaning',
    professionalSubtitle: 'Powerful solutions for industrial facilities and commercial spaces',
    warranty24: '24 Month Warranty',
    highInspection: 'High Quality Control',
    spareParts: 'Spare Parts',
    technicalSupport: 'Technical Support',
    whyElerein: 'Why Choose Elerein?',
    productCatalogs: 'Product Catalogs',
    downloadAllCatalogs: 'Download All Catalogs',
    
    // Rental
    rentalTitle: 'Operational Rental',
    rentalSubtitle: 'Flexible and cost-effective cleaning equipment rental solutions',
    aiAssisted: 'AI-Assisted',
    rentalQuote: 'Rent a seamless, sustainable, and controlled cleaning system, not just a machine',
    operationBenefits: 'Clear Data Flow in Operations Management',
    operationBenefitsDesc: 'Keep all your processes under control with AI-assisted smart rental model',
    financeTitle: 'Finance',
    financeFixed: 'Fixed Monthly Cost',
    financeFixedDesc: 'Predictable budget planning',
    financeNoCap: 'Zero CAPEX',
    financeNoCapDesc: 'No upfront investment',
    financePredictable: 'Predictable',
    financePredictableDesc: 'No hidden costs',
    operationTitle: 'Operation',
    operationContinuity: 'Uninterrupted Service',
    operationContinuityDesc: 'Proactive maintenance and support',
    operationAI: 'AI Monitoring',
    operationAIDesc: 'Real-time performance tracking',
    operationMaintenance: 'Periodic Maintenance',
    operationMaintenanceDesc: 'All maintenance included',
    procurementTitle: 'Procurement',
    procurementSingle: 'Single Supplier',
    procurementSingleDesc: 'Simplified procurement process',
    procurementSimple: 'Single Contract',
    procurementSimpleDesc: 'Easy management',
    managementTitle: 'Management',
    managementPerformance: 'Performance Monitoring',
    managementPerformanceDesc: 'Detailed reporting and analysis',
    managementRisk: 'Risk Management',
    managementRiskDesc: 'Reduced operational risk',
    comparisonTitle: 'Operational, Management and Financial Evaluation',
    comparisonDesc: 'Compare classic purchase with AI-assisted rental model',
    comparisonCriteria: 'Evaluation Criteria',
    comparisonClassic: 'Classic Purchase',
    comparisonAI: 'AI-Assisted Smart Rental',
    comparisonInvestment: 'Initial Investment',
    comparisonClassicInv: 'High CAPEX required',
    comparisonAIInv: 'Zero CAPEX',
    comparisonCashFlow: 'Cash Flow',
    comparisonClassicCash: 'Large upfront payment',
    comparisonAICash: 'Predictable monthly payment',
    comparisonCost: 'Total Cost of Ownership',
    comparisonClassicCost: 'High and variable',
    comparisonAICost: 'Fixed and predictable',
    comparisonMaintenance: 'Maintenance & Repair',
    comparisonClassicMain: 'Additional cost and time',
    comparisonAIMain: 'Included and planned',
    comparisonControl: 'Operation Control',
    comparisonClassicControl: 'Manual tracking',
    comparisonAIControl: 'AI-powered automatic monitoring',
    rentalProductsDesc: 'All ELEREIN cleaning machines are available in rental model',
    rentalCTA: 'Discover AI-Assisted Rental Model',
    rentalCTADesc: 'Contact us now for a customized solution',
    economicSolution: 'Cost-Effective Solution',
    flexibleTerms: 'Flexible Terms',
    maintenanceIncluded: 'Maintenance Included',
    renewalGuarantee: 'Renewal Guarantee',
    rentalAdvantages: 'Operational Rental Advantages',
    availableProducts: 'Products Available for Rent',
    requestQuote: 'Request Quote',
    
    // Product Descriptions
    e1Desc: 'Compact and powerful floor cleaning machine. Ideal solution for narrow spaces.',
    e30Desc: 'Compact cleaning machine with 30-liter tank capacity. Excellent performance for medium-sized areas.',
    e60Desc: '55-liter walk-behind cleaning machine. Battery-powered model that can easily clean large areas.',
    e100Desc: 'Cleaning machine with 110-liter tank and 4,200 m2/hour working capacity.',
    e130Desc: 'Cleaning machine with 130-liter tank and 5,300 m2/hour working capacity.',
    e250Desc: 'Industrial ride-on cleaning machine with 250-liter tank capacity. Ideal for large facilities.',
    
    // Product Names
    e1Name: 'E1 Floor Cleaning Machine',
    e30Name: 'E30 Floor Cleaning Machine',
    e60Name: 'E60 Floor Cleaning Machine',
    e100Name: 'E100 Industrial Ride-on Floor Cleaning Machine',
    e130Name: 'E130 Industrial Ride-on Floor Cleaning Machine',
    e250Name: 'E250 Industrial Cleaning Machine',
    compactName: 'Compact Floor Cleaner',
    
    // About Page
    aboutContent1: 'ServiceMacro is a Turkey-based technology and service company operating in the fields of industrial cleaning machinery sales, rental, and after-sales services.',
    aboutContent2: 'Established with the experience gained from over 20 years in the sector, our company aims to improve after-sales service quality, increase operational efficiency, and offer sustainable solutions in the cleaning equipment market.',
    aboutContent3: 'ServiceMacro provides all its services from sales and rental processes to technical service, spare parts supply, and second-hand operations with a brand-independent total supplier approach.',
    aboutContent4: 'With its customer satisfaction-focused structure, strong technical infrastructure, and experienced team, it provides the most suitable solution to business partners\' needs quickly and effectively.',
    aboutContent5: 'Our company is based on using equipment for an optimal period and managing it in a sustainable cycle with environmentally conscious recycling processes.',
    aboutContent6: 'This approach has enabled ServiceMacro to go beyond being just a product provider and become a solution partner that creates added value in the industrial cleaning sector.',
    aboutContent7: 'Strengthened by the ELEREIN European Partnership, ServiceMacro has become a respected brand serving throughout Europe with its wide product portfolio and technical capability in the field of cleaning machines.',
    aboutContent8: 'With its service approach compatible with developing technology, environmentally friendly and innovative, ServiceMacro is advancing quality standards in the sector every day.',
    partnershipContent1: 'Strengthened by the ELEREIN European Partnership, ServiceMacro has become a respected brand serving throughout Europe with its wide product portfolio and technical capability in the field of cleaning machines.',
    partnershipContent2: 'By combining our over 20 years of industry experience with ELEREIN\'s innovative technologies, we provide the best service to our customers.'
  },
  
  de: {
    // Navbar
    products: 'Produkte',
    operationalRental: 'Operatives Leasing',
    professional: 'Industrielle Reinigungsmaschinen',
    solutions: 'Lösungen',
    service: 'Service',
    about: 'Über uns',
    company: 'Firma',
    sustainability: 'Nachhaltigkeit',
    career: 'Karriere',
    contact: 'Kontakt',
    
    // Home
    homeRentalTitle: 'Operatives Leasing',
    homeRentalDesc: 'Entdecken Sie unsere flexiblen Mietlösungen',
    homeProfessionalTitle: 'Professionelle Reinigung',
    homeProfessionalDesc: 'Entdecken Sie unser komplettes Produktsortiment',
    learnMore: 'Mehr erfahren',
    
    // Featured Sections
    featuredSustainabilityTitle: 'Verantwortungsvoll Werte schaffen',
    featuredSustainabilityDesc: 'Entdecken Sie Nachhaltigkeit jenseits von Produkten und Dienstleistungen',
    featuredNewMachineTitle: 'Elerein Design-Kraft',
    featuredNewMachineDesc: 'E130. Der Weg zum Erfolg ist Einfachheit',
    featuredCareerTitle: 'Ein vielversprechender Karriereweg',
    featuredCareerDesc: 'Werden Sie Teil unseres Teams und verwirklichen Sie Ihre inspirierenden Ideen',
    featuredContactTitle: 'Wir sind gerne für Sie da',
    featuredContactDesc: 'Kontaktieren Sie uns und finden Sie die Lösung für jede Herausforderung im Reinigungsbereich',
    readMore: 'Weiterlesen',
    
    // Footer
    allRightsReserved: 'Alle Rechte vorbehalten.',
    turkeyDistributor: 'Türkei Vertriebspartner Service Macro',
    footerProducts: 'Produkte',
    footerServices: 'Dienstleistungen',
    footerCompany: 'Firma',
    footerSupport: 'Unterstützung',
    
    // Contact
    contactTitle: 'Kontakt',
    contactSubtitle: 'Wir sind hier, um Ihnen zu helfen',
    getInTouch: 'Kontaktieren Sie uns',
    contactDesc: 'Sie können uns für Ihre Fragen und Anfragen erreichen. Unser Expertenteam wird Ihnen so schnell wie möglich helfen.',
    address: 'Adresse',
    phone: 'Telefon',
    email: 'E-Mail',
    workingHours: 'Arbeitszeiten',
    workingHoursDesc: 'Montag - Freitag: 09:00 - 18:00\nSamstag: 09:00 - 14:00\nSonntag: Geschlossen',
    sendMessage: 'Nachricht senden',
    fullName: 'Vollständiger Name',
    subject: 'Betreff',
    message: 'Nachricht',
    send: 'Senden',
    
    // Products
    ourProducts: 'Unsere Produkte',
    view: 'Ansehen',
    catalog: 'Katalog',
    
    // Catalog
    catalogTitle: 'Elerein Produktkatalog 2025',
    backButton: 'Zurück',
    downloadPDF: 'PDF herunterladen',
    viewCatalog: 'Katalog ansehen',
    
    // About
    aboutTitle: 'Über uns',
    aboutSubtitle: 'ServiceMacro - Industrielle Reinigungslösungen',
    ourValues: 'Unsere Werte',
    quality: 'Qualität',
    efficiency: 'Effizienz',
    customerFocus: 'Kundenorientierung',
    partnershipTitle: 'ELEREIN Partnerschaft',
    
    // Professional
    professionalTitle: 'Professionelle Reinigung',
    professionalSubtitle: 'Leistungsstarke Lösungen für Industrieanlagen und Gewerbeflächen',
    warranty24: '24 Monate Garantie',
    highInspection: 'Hohe Qualitätskontrolle',
    spareParts: 'Ersatzteile',
    technicalSupport: 'Technischer Support',
    whyElerein: 'Warum Elerein wählen?',
    productCatalogs: 'Produktkataloge',
    downloadAllCatalogs: 'Alle Kataloge herunterladen',
    
    // Rental
    rentalTitle: 'Operatives Leasing',
    rentalSubtitle: 'Flexible und wirtschaftliche Mietlösungen für Reinigungsgeräte',
    economicSolution: 'Wirtschaftliche Lösung',
    flexibleTerms: 'Flexible Laufzeiten',
    maintenanceIncluded: 'Wartung inklusive',
    renewalGuarantee: 'Erneuerungsgarantie',
    rentalAdvantages: 'Vorteile des operativen Leasings',
    availableProducts: 'Verfügbar zur Miete',
    requestQuote: 'Angebot anfordern',
    
    // Product Descriptions
    e1Desc: 'Kompakte und leistungsstarke Bodenreinigungsmaschine. Ideale Lösung für enge Räume.',
    e30Desc: 'Kompakte Reinigungsmaschine mit 30-Liter-Tankkapazität. Hervorragende Leistung für mittelgroße Bereiche.',
    e60Desc: '55-Liter-Aufsitzreinigungsmaschine. Batteriebetriebenes Modell für große Flächen.',
    e100Desc: 'Reinigungsmaschine mit 110-Liter-Tank und 4.200 m2/Stunde Arbeitskapazität.',
    e130Desc: 'Reinigungsmaschine mit 130-Liter-Tank und 5.300 m2/Stunde Arbeitskapazität.',
    e250Desc: 'Industrielle Aufsitzreinigungsmaschine mit 250-Liter-Tankkapazität. Ideal für große Anlagen.',
    
    // Product Names
    e1Name: 'E1 Bodenreinigungsmaschine',
    e30Name: 'E30 Bodenreinigungsmaschine',
    e60Name: 'E60 Bodenreinigungsmaschine',
    e100Name: 'E100 Industrielle Aufsitz-Bodenreinigungsmaschine',
    e130Name: 'E130 Industrielle Aufsitz-Bodenreinigungsmaschine',
    e250Name: 'E250 Industrielle Reinigungsmaschine',
    compactName: 'Kompakter Bodenreiniger',
    
    // About Page
    aboutContent1: 'ServiceMacro ist ein in der Türkei ansässiges Technologie- und Dienstleistungsunternehmen, das in den Bereichen Verkauf, Vermietung und Kundendienst von Industriereinigungsmaschinen tätig ist.',
    aboutContent2: 'Unser Unternehmen wurde mit der Erfahrung von über 20 Jahren in der Branche gegründet und zielt darauf ab, die Qualität des Kundendienstes zu verbessern, die betriebliche Effizienz zu steigern und nachhaltige Lösungen auf dem Markt für Reinigungsgeräte anzubieten.',
    aboutContent3: 'ServiceMacro bietet alle seine Dienstleistungen von Verkaufs- und Vermietungsprozessen bis hin zu technischem Service, Ersatzteilversorgung und Gebrauchtwarengeschäften mit einem markenunabhängigen Total-Supplier-Ansatz an.',
    aboutContent4: 'Mit seiner kundenorientierten Struktur, starken technischen Infrastruktur und erfahrenem Team bietet es Geschäftspartnern schnell und effektiv die am besten geeignete Lösung für ihre Bedürfnisse.',
    aboutContent5: 'Unser Unternehmen basiert auf der optimalen Nutzung von Geräten und deren Verwaltung in einem nachhaltigen Kreislauf mit umweltbewussten Recyclingprozessen.',
    aboutContent6: 'Dieser Ansatz hat es ServiceMacro ermöglicht, über die reine Produktbereitstellung hinauszugehen und ein Lösungspartner zu werden, der Mehrwert im Bereich der industriellen Reinigung schafft.',
    aboutContent7: 'Gestärkt durch die ELEREIN-Europäische Partnerschaft ist ServiceMacro zu einer angesehenen Marke geworden, die europaweit mit einem breiten Produktportfolio und technischer Kompetenz im Bereich Reinigungsmaschinen tätig ist.',
    aboutContent8: 'Mit seinem technologiekompatiblen, umweltfreundlichen und innovativen Serviceverständnis treibt ServiceMacro die Qualitätsstandards in der Branche jeden Tag weiter voran.',
    partnershipContent1: 'Gestärkt durch die ELEREIN-Europäische Partnerschaft ist ServiceMacro zu einer angesehenen Marke geworden, die europaweit mit einem breiten Produktportfolio und technischer Kompetenz im Bereich Reinigungsmaschinen tätig ist.',
    partnershipContent2: 'Durch die Kombination unserer über 20-jährigen Branchenerfahrung mit den innovativen Technologien von ELEREIN bieten wir unseren Kunden den besten Service.'
  },
  
  ar: {
    // Navbar
    products: 'المنتجات',
    operationalRental: 'التأجير التشغيلي',
    professional: 'آلات التنظيف الصناعية',
    solutions: 'الحلول',
    service: 'الخدمة',
    about: 'معلومات عنا',
    company: 'الشركة',
    sustainability: 'الاستدامة',
    career: 'الوظائف',
    contact: 'اتصل',
    
    // Home
    homeRentalTitle: 'التأجير التشغيلي',
    homeRentalDesc: 'اكتشف حلول الإيجار المرنة لدينا',
    homeProfessionalTitle: 'التنظيف الاحترافي',
    homeProfessionalDesc: 'اكتشف مجموعة منتجاتنا الكاملة',
    learnMore: 'معرفة المزيد',
    
    // Featured Sections
    featuredSustainabilityTitle: 'خلق القيمة بمسؤولية',
    featuredSustainabilityDesc: 'اكتشف الاستدامة بما يتجاوز المنتجات والخدمات',
    featuredNewMachineTitle: 'قوة تصميم Elerein',
    featuredNewMachineDesc: 'E130. البساطة هي طريق النجاح',
    featuredCareerTitle: 'مسار وظيفي واعد',
    featuredCareerDesc: 'انضم إلينا واجعل أفكارك الملهمة حقيقة',
    featuredContactTitle: 'نحن هنا لتلبية طلباتكم بكل سرور',
    featuredContactDesc: 'اتصل بنا واعثر على الحل الذي تبحث عنه لكل تحدٍ تواجهه في التنظيف',
    readMore: 'اقرأ المزيد',
    
    // Footer
    allRightsReserved: 'جميع الحقوق محفوظة.',
    turkeyDistributor: 'موزع تركيا سيرفيس ماكرو',
    footerProducts: 'المنتجات',
    footerServices: 'الخدمات',
    footerCompany: 'الشركة',
    footerSupport: 'الدعم',
    
    // Contact
    contactTitle: 'اتصل بنا',
    contactSubtitle: 'نحن هنا لمساعدتك',
    getInTouch: 'تواصل معنا',
    contactDesc: 'يمكنك التواصل معنا لأسئلتك وطلباتك. سيساعدك فريق الخبراء لدينا في أقرب وقت ممكن.',
    address: 'العنوان',
    phone: 'الهاتف',
    email: 'البريد الإلكتروني',
    workingHours: 'ساعات العمل',
    workingHoursDesc: 'الاثنين - الجمعة: 09:00 - 18:00\nالسبت: 09:00 - 14:00\nالأحد: مغلق',
    sendMessage: 'إرسال رسالة',
    fullName: 'الاسم الكامل',
    subject: 'الموضوع',
    message: 'الرسالة',
    send: 'إرسال',
    
    // Products
    ourProducts: 'منتجاتنا',
    view: 'عرض',
    catalog: 'الكتالوج',
    
    // Catalog
    catalogTitle: 'كتالوج منتجات إليرين 2025',
    backButton: 'رجوع',
    downloadPDF: 'تحميل PDF',
    viewCatalog: 'عرض الكتالوج',
    
    // About
    aboutTitle: 'معلومات عنا',
    aboutSubtitle: 'سيرفيس ماكرو - حلول التنظيف الصناعي',
    ourValues: 'قيمنا',
    quality: 'الجودة',
    efficiency: 'الكفاءة',
    customerFocus: 'التركيز على العملاء',
    partnershipTitle: 'شراكة ELEREIN',
    
    // Professional
    professionalTitle: 'التنظيف الاحترافي',
    professionalSubtitle: 'حلول قوية للمنشآت الصناعية والمساحات التجارية',
    warranty24: 'ضمان 24 شهر',
    highInspection: 'رقابة جودة عالية',
    spareParts: 'قطع الغيار',
    technicalSupport: 'الدعم الفني',
    whyElerein: 'لماذا تختار إليرين؟',
    productCatalogs: 'كتالوجات المنتجات',
    downloadAllCatalogs: 'تحميل جميع الكتالوجات',
    
    // Rental
    rentalTitle: 'التأجير التشغيلي',
    rentalSubtitle: 'حلول تأجير معدات التنظيف المرنة والاقتصادية',
    economicSolution: 'حل اقتصادي',
    flexibleTerms: 'شروط مرنة',
    maintenanceIncluded: 'الصيانة مشمولة',
    renewalGuarantee: 'ضمان التجديد',
    rentalAdvantages: 'مزايا التأجير التشغيلي',
    availableProducts: 'متاح للإيجار',
    requestQuote: 'طلب عرض سعر',
    
    // Product Descriptions
    e1Desc: 'آلة تنظيف الأرضيات المدمجة والقوية. حل مثالي للمساحات الضيقة.',
    e30Desc: 'آلة تنظيف مدمجة بخزان سعة 30 لترًا. أداء ممتاز للمناطق متوسطة الحجم.',
    e60Desc: 'آلة تنظيف دفع بسعة 55 لترًا. نموذج يعمل بالبطارية يمكنه تنظيف المساحات الكبيرة بسهولة.',
    e100Desc: 'آلة تنظيف بخزان 110 لتر وقدرة عمل 4,200 م2/ساعة.',
    e130Desc: 'آلة تنظيف بخزان 130 لتر وقدرة عمل 5,300 م2/ساعة.',
    e250Desc: 'آلة تنظيف صناعية بخزان سعة 250 لترًا. مثالية للمنشآت الكبيرة.',
    
    // Product Names
    e1Name: 'آلة تنظيف الأرضيات E1',
    e30Name: 'آلة تنظيف الأرضيات E30',
    e60Name: 'آلة تنظيف الأرضيات E60',
    e100Name: 'آلة تنظيف الأرضيات الصناعية E100',
    e130Name: 'آلة تنظيف الأرضيات الصناعية E130',
    e250Name: 'آلة التنظيف الصناعية E250',
    compactName: 'منظف الأرضيات المدمج',
    
    // About Page
    aboutContent1: 'سيرفيس ماكرو هي شركة تكنولوجيا وخدمات مقرها تركيا تعمل في مجالات مبيعات آلات التنظيف الصناعية والإيجار وخدمات ما بعد البيع.',
    aboutContent2: 'تأسست شركتنا بالخبرة المكتسبة من أكثر من 20 عامًا في هذا القطاع، وتهدف إلى تحسين جودة خدمة ما بعد البيع وزيادة الكفاءة التشغيلية وتقديم حلول مستدامة في سوق معدات التنظيف.',
    aboutContent3: 'تقدم سيرفيس ماكرو جميع خدماتها من عمليات البيع والإيجار إلى الخدمة الفنية وتوريد قطع الغيار وعمليات السلع المستعملة بنهج موزع شامل مستقل عن العلامة التجارية.',
    aboutContent4: 'مع هيكلها الذي يركز على رضا العملاء والبنية التحتية التقنية القوية والفريق ذو الخبرة، توفر الحلول الأنسب لاحتياجات شركاء الأعمال بسرعة وفعالية.',
    aboutContent5: 'تستند شركتنا على استخدام المعدات لفترة مثالية وإدارتها في دورة مستدامة بعمليات إعادة تدوير واعية بيئيًا.',
    aboutContent6: 'مكّن هذا النهج سيرفيس ماكرو من تجاوز كونها مجرد مزود منتجات وأن تصبح شريكًا في الحلول يخلق قيمة مضافة في قطاع التنظيف الصناعي.',
    aboutContent7: 'تقوت سيرفيس ماكرو بشراكة ELEREIN الأوروبية، لتصبح علامة تجارية محترمة تقدم خدماتها في جميع أنحاء أوروبا بمحفظة منتجات واسعة وقدرة تقنية في مجال آلات التنظيف.',
    aboutContent8: 'بنهج خدمة متوافق مع التكنولوجيا المتطورة وصديق للبيئة ومبتكر، تدفع سيرفيس ماكرو معايير الجودة في القطاع إلى الأمام كل يوم.',
    partnershipContent1: 'تقوت سيرفيس ماكرو بشراكة ELEREIN الأوروبية، لتصبح علامة تجارية محترمة تقدم خدماتها في جميع أنحاء أوروبا بمحفظة منتجات واسعة وقدرة تقنية في مجال آلات التنظيف.',
    partnershipContent2: 'من خلال الجمع بين خبرتنا في الصناعة التي تزيد عن 20 عامًا والتقنيات المبتكرة لـ ELEREIN، نقدم أفضل خدمة لعملائنا.'
  },
  
  zh: {
    // Navbar
    products: '产品',
    operationalRental: '运营租赁',
    professional: '工业清洁机械',
    solutions: '解决方案',
    service: '服务',
    about: '关于我们',
    company: '公司',
    sustainability: '可持续性',
    career: '职业',
    contact: '联系我们',
    
    // Home
    homeRentalTitle: '运营租赁',
    homeRentalDesc: '探索我们灵活的租赁解决方案',
    homeProfessionalTitle: '专业清洁',
    homeProfessionalDesc: '探索我们的全系列产品',
    learnMore: '了解更多',
    
    // Featured Sections
    featuredSustainabilityTitle: '以责任创造价值',
    featuredSustainabilityDesc: '探索产品和服务之外的可持续性',
    featuredNewMachineTitle: 'Elerein 设计力量',
    featuredNewMachineDesc: 'E130. 简单是成功之路',
    featuredCareerTitle: '充满前景的职业道路',
    featuredCareerDesc: '加入我们，实现您的创新想法',
    featuredContactTitle: '我们随时为您服务',
    featuredContactDesc: '联系我们，找到您在清洁方面遇到的每个挑战的解决方案',
    readMore: '阅读更多',
    
    // Footer
    allRightsReserved: '版权所有。',
    turkeyDistributor: '土耳其分销商 Service Macro',
    
    // Contact
    contactTitle: '联系我们',
    contactSubtitle: '我们随时为您提供帮助',
    getInTouch: '与我们联系',
    contactDesc: '如有疑问和需求，请与我们联系。我们的专家团队将尽快为您提供帮助。',
    address: '地址',
    phone: '电话',
    email: '电子邮件',
    workingHours: '工作时间',
    workingHoursDesc: '周一至周五：09:00 - 18:00\n周六：09:00 - 14:00\n周日：休息',
    sendMessage: '发送消息',
    fullName: '全名',
    subject: '主题',
    message: '消息',
    send: '发送',
    
    // Products
    ourProducts: '我们的产品',
    view: '查看',
    catalog: '目录',
    
    // Catalog
    catalogTitle: 'Elerein 产品目录 2025',
    backButton: '返回',
    downloadPDF: '下载PDF',
    viewCatalog: '查看目录',
    
    // About
    aboutTitle: '关于我们',
    aboutSubtitle: 'ServiceMacro - 工业清洁解决方案',
    ourValues: '我们的价值观',
    quality: '质量',
    efficiency: '效率',
    customerFocus: '以客户为中心',
    partnershipTitle: 'ELEREIN 合作伙伴关系',
    
    // Professional
    professionalTitle: '专业清洁',
    professionalSubtitle: '为工业设施和商业区域提供强大的解决方案',
    warranty24: '24个月保修',
    highInspection: '高标准检验',
    spareParts: '备件',
    technicalSupport: '技术支持',
    whyElerein: '为什么选择Elerein？',
    productCatalogs: '产品目录',
    downloadAllCatalogs: '下载所有目录',
    
    // Rental
    rentalTitle: '运营租赁',
    rentalSubtitle: '灵活且经济的清洁设备租赁解决方案',
    economicSolution: '经济解决方案',
    flexibleTerms: '灵活的期限',
    maintenanceIncluded: '包含维护',
    renewalGuarantee: '续订保证',
    rentalAdvantages: '运营租赁优势',
    availableProducts: '可租赁产品',
    requestQuote: '请求报价',
    
    // Product Descriptions
    e1Desc: '紧凑而强大的地板清洁机。适合狭窄空间的理想解决方案。',
    e30Desc: '配备30升水箱的紧凑型清洁机。为中等规模区域提供卓越性能。',
    e60Desc: '55升步行式清洁机。电池供电型号，可轻松清洁大面积区域。',
    e100Desc: '配备110升水箱，工作能力为4,200平方米/小时的清洁机。',
    e130Desc: '配备130升水箱，工作能力为5,300平方米/小时的清洁机。',
    e250Desc: '配备250升水箱的工业驾驶式清洁机。适合大型设施。',
    
    // Product Names
    e1Name: 'E1 地板清洁机',
    e30Name: 'E30 地板清洁机',
    e60Name: 'E60 地板清洁机',
    e100Name: 'E100 工业驾驶式地板清洁机',
    e130Name: 'E130 工业驾驶式地板清洁机',
    e250Name: 'E250 工业清洁机',
    compactName: '紧凑型地板清洁机',
    
    // About Page
    aboutContent1: 'ServiceMacro是一家总部位于土耳其的技术和服务公司，在工业清洁机械销售、租赁和售后服务领域开展业务。',
    aboutContent2: '我们公司凭借在该行业20多年的经验而成立，旨在提高售后服务质量、提高运营效率并在清洁设备市场提供可持续的解决方案。',
    aboutContent3: 'ServiceMacro以品牌独立的全面供应商方式提供从销售和租赁流程到技术服务、备件供应和二手商品运营的所有服务。',
    aboutContent4: '凭借其以客户满意为中心的结构、强大的技术基础设施和经验丰富的团队，它快速有效地为业务合作伙伴的需求提供最合适的解决方案。',
    aboutContent5: '我们公司基于最佳使用设备期限，并通过环保的回收流程在可持续循环中进行管理。',
    aboutContent6: '这种方法使ServiceMacro超越了仅仅作为产品提供商的角色，成为在工业清洁领域创造附加值的解决方案合作伙伴。',
    aboutContent7: '凭借ELEREIN欧洲合作伙伴关系的加强，ServiceMacro已成为一个受尊敬的品牌，以其在清洁机械领域的广泛产品组合和技术能力在整个欧洲提供服务。',
    aboutContent8: '凭借符合发展技术、环保和创新的服务理念，ServiceMacro每天都在推动行业质量标准向前发展。',
    partnershipContent1: '凭借ELEREIN欧洲合作伙伴关系的加强，ServiceMacro已成为一个受尊敬的品牌，以其在清洁机械领域的广泛产品组合和技术能力在整个欧洲提供服务。',
    partnershipContent2: '通过结合我们20多年的行业经验和ELEREIN的创新技术，我们为客户提供最好的服务。'
  }
};

export const getTranslation = (language, key) => {
  return translations[language]?.[key] || translations['tr'][key] || key;
};
